<template>
  <v-dialog
    v-model="showDialog"
    scrollable
    fullscreen
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card tile>
      <v-toolbar dense>
        <v-btn @click="closeDialog()" icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title class="subtitle-1">Breakdown by Orders</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-badge overlap color="primary darken-4" :content="totalItems"></v-badge>
      </v-toolbar>

      <v-card-text class="mx-0 px-0">
        <v-data-table
          v-model="selected"
          :fixed-header="true"
          :headers="headers"
          :items="breakdownProducts"
          single-expand
          item-key="id"
          class="elevation-1"
          height="65vh"
          :items-per-page="50"
          :footer-props="{
            'items-per-page-options': [50]
          }"
          must-sort
          :search="search"
        >
          <template v-slot:top>
            <div class="d-flex">
              <v-spacer></v-spacer>

              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                color="primary darken-4"
                single-line
                hide-details
                filled
                clearable
              ></v-text-field>
            </div>

            <v-divider v-show="isCustomizedTable"></v-divider>
          </template>

          <template v-slot:item.name="{ item }">
            <div class="mx-auto" v-text="item.name"></div>
          </template>

          <template v-slot:item.price="{ item }">
            <div class="mx-auto" v-text="item.price"></div>
          </template>

          <template v-slot:item.quantity="{ item }">
            <div class="mx-auto" v-text="item.quantity"></div>
          </template>

          <template v-slot:item.modified="{ item }">
            <div class="mx-auto" v-text="item.modified"></div>
          </template>

          <template v-slot:item.order="{ item }">
            <div class="mx-auto" v-text="item.order"></div>
          </template>

          <template v-slot:item.attendant="{ item }">
            <div class="mx-auto" v-text="item.attendant"></div>
          </template>

          <template v-slot:item.total="{ item }">
            <div class="mx-auto" v-text="item.total"></div>
          </template>
        </v-data-table>
      </v-card-text>

      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BreakdownByOrdersDialog",
  data() {
    return {
      search: "",
      selected: [],

      headers: [
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        { text: "Price (GH₵)", align: "center", value: "price" },
        { text: "Quantity", align: "center", value: "quantity" },
        { text: "Modified", align: "center", value: "modified" },
        { text: "Order", align: "center", value: "order" },
        { text: "Attendant", align: "center", value: "attendant" },

        {
          text: "Total (GH₵)",
          align: "center",
          value: "total"
        }
      ]
    };
  },

  components: {},

  methods: {
    closeDialog() {
      this.$store.commit("setBreakdownByOrdersDialog", false);
    }
  },

  watch: {},

  computed: {
    showDialog() {
      return this.$store.state.analyses.breakdownByOrdersDialog;
    },

    isCustomizedTable() {
      return true;
    },

    breakdownProducts() {
      return this.$store.state.analyses.breakdownItemsByOrders;
    },

    totalItems() {
      return this.$store.state.analyses.breakdownItemsByOrders.length.toString();
    }
  }
};
</script>

<style>
</style>